import {LogUserComponent} from "./LogUser";
import {Fragment, useContext} from "react";
import {AuthContext} from "./Global/AuthContext";
import {MainComponent} from "./reports/MainComponent";
import {AppBar, Button, Toolbar, Typography} from "@mui/material";
import {ShowUnitCheckComponent} from "./reports/ShowUnitCheck";

function App() {

    const { logged, dataUser, handlingCloseSession } = useContext(AuthContext);

    return (
        logged ?
            <Fragment>

                <AppBar position="static">
                    <Toolbar >
                        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                            Control y revicion de la unidad
                        </Typography>
                        <Button variant="contained" color="error" onClick={handlingCloseSession}>
                                Cerrar session
                        </Button>

                    </Toolbar>
                </AppBar>
                {
                    !!dataUser && (dataUser.permiso === "administrador" || dataUser.permiso === "2") &&
                    <MainComponent />
                }

                {
                    !!dataUser && (dataUser.permiso === "administrador" || dataUser.permiso === "15") &&
                    <ShowUnitCheckComponent/>
                }
            </Fragment>:
            <LogUserComponent/>
    );
}

export default App;
